import { render, staticRenderFns } from "./DiscountShippingFee.vue?vue&type=template&id=35b596ec&"
import script from "./DiscountShippingFee.vue?vue&type=script&lang=ts&"
export * from "./DiscountShippingFee.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports